import type { DeepPartial, Styles } from 'klinecharts'
import type { EdgeTheme } from '../types/chart'
import { darkTheme } from './dark'
import { lightTheme } from './light'

export function applyTheme(theme?: EdgeTheme): DeepPartial<Styles> {
  if (!theme || theme === 'dark') return darkTheme
  if (theme === 'light') return lightTheme
  return theme
}
